<script setup>
  const { data, width, height } = defineProps(['data', 'width', 'height']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <figcaption>
    <slot />
  </figcaption>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  figcaption {
    @include column(2, 6);
    margin-top: px(20);

    font-size: px(14);

    @include break-small {
      @include column(2, 7);
      margin-top: px(14);

      font-size: px(11);
    }

    @include break-phone {
      @include column(1, 12);
      margin-top: px(12);
    }
  }
</style>
